module.exports = __webpack_public_path__ + "static/media/hit-blocked.d31a0d4e.png";